import MasterCrudPage from "../../components/MasterCrudPage";
import { assetTypeApi } from "../../api/masterApi";

export default function AssetType() {
  return (
    <MasterCrudPage
      title="Asset Type Master"
      description="Define the asset types available in Asset Master."
      idKey="asset_type_id"
      api={assetTypeApi}
      listLabel="asset types"
      useJson
      fields={[
        {
          name: "asset_type_name",
          label: "Asset Type",
          type: "text",
          required: true,
          fullWidth: true,
          placeholder: "Enter asset type",
        },
      ]}
      columns={[
        { key: "asset_type_id", label: "Asset Type" },
        { key: "asset_type_name", label: "Asset Type" },
      ]}
    />
  );
}
